export default "__VITE_ASSET__606354af__"